import { render } from "./ShipmentDetails.vue?vue&type=template&id=7ec4603b&scoped=true"
import script from "./ShipmentDetails.vue?vue&type=script&lang=js"
export * from "./ShipmentDetails.vue?vue&type=script&lang=js"

import "./ShipmentDetails.vue?vue&type=style&index=0&id=7ec4603b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec4603b"]])

export default __exports__